import { c as _c } from "react-compiler-runtime";
import { collaborationSidebarStateFollowerReady } from '../../store/collaborationSidebarState';
import { useCollaborationSidebarActions, useStateValue } from '../../store/collaborationSidebarProvider';

/**
 * Promise-based accessor intended for scenarios where it is not practical to
 * source this data through the React hook (e.g. imperative code paths outside
 * of a component).
 *
 * Prefer `useCollaborationSidebarOpenState` where possible — the hook
 * re-renders as the underlying state changes, while this function returns a
 * one-time snapshot of the state.
 *
 * Resolves with default state if no leader responds within the follower-ready timeout.
 */
export const getCollaborationSidebarOpenState = async () => {
  const follower = await collaborationSidebarStateFollowerReady();
  return {
    isOpen: follower.getState().isOpen,
    isCommentModeActive: follower.getState().isCommentModeActive,
    tab: follower.getState().tab,
    openComments: follower.actions.openComments,
    openActivityFeed: follower.actions.openActivityFeed,
    openCalendar: follower.actions.openCalendar,
    openApprovals: follower.actions.openApprovals,
    openCopilot: follower.actions.openCopilot,
    openReview: follower.actions.openReview,
    openTasks: follower.actions.openTasks,
    closeSidebar: follower.actions.closeSidebar
  };
};
export const useCollaborationSidebarOpenState = () => {
  "use memo";

  const $ = _c(12);
  const isOpen = useStateValue("isOpen");
  const tab = useStateValue("tab");
  const isCommentModeActive = useStateValue("isCommentModeActive");
  const actions = useCollaborationSidebarActions();
  let t0;
  if ($[0] !== actions.closeSidebar || $[1] !== actions.openActivityFeed || $[2] !== actions.openApprovals || $[3] !== actions.openCalendar || $[4] !== actions.openComments || $[5] !== actions.openCopilot || $[6] !== actions.openReview || $[7] !== actions.openTasks || $[8] !== isCommentModeActive || $[9] !== isOpen || $[10] !== tab) {
    t0 = {
      isOpen,
      openComments: actions.openComments,
      openActivityFeed: actions.openActivityFeed,
      openCalendar: actions.openCalendar,
      openApprovals: actions.openApprovals,
      openCopilot: actions.openCopilot,
      openReview: actions.openReview,
      openTasks: actions.openTasks,
      closeSidebar: actions.closeSidebar,
      isCommentModeActive,
      tab
    };
    $[0] = actions.closeSidebar;
    $[1] = actions.openActivityFeed;
    $[2] = actions.openApprovals;
    $[3] = actions.openCalendar;
    $[4] = actions.openComments;
    $[5] = actions.openCopilot;
    $[6] = actions.openReview;
    $[7] = actions.openTasks;
    $[8] = isCommentModeActive;
    $[9] = isOpen;
    $[10] = tab;
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  return t0;
};